const t = "opacityEnter_8LCOA", i = "opacityEnterActive_tsWJH", c = "opacityExit_vwnLt", o = "opacityExitActive_ET7uY", a = {
  opacityEnter: t,
  opacityEnterActive: i,
  opacityExit: c,
  opacityExitActive: o
};
export {
  a as default,
  t as opacityEnter,
  i as opacityEnterActive,
  c as opacityExit,
  o as opacityExitActive
};
//# sourceMappingURL=opacity.module.scss.js.map
